import classNames from 'classnames';
import React, {ComponentProps} from 'react';

import Row from '../../../common/Row';

type ToggleButtonProps = Omit<ComponentProps<'button'>, 'onClick'> & {
  id: string;
  label: string;
  toggled: boolean;
  onClick: (id: string) => void;
};

const ToggleButton = (props: ToggleButtonProps) => {
  const {id, label, toggled, onClick} = props;
  return (
    <button
      type="button"
      className={classNames(
        'left-8 bottom-8 text-xs rounded-full py-0.5 px-8 font-medium border hover:border-primary-300',
        toggled
          ? 'bg-primary-300 border-primary-300 hover:border-gray-100'
          : 'bg-white border-gray-100 hover:border-primary-300'
      )}
      onClick={() => onClick(id)}
    >
      <Row
        className={classNames(
          'grow text-2xs font-normal place-items-center',
          toggled ? 'text-primary-800' : 'text-gray-200'
        )}
      >
        {label}
      </Row>
    </button>
  );
};

export default ToggleButton;
